/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetFeatures200
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType } from '../../orval-mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Authorities: **Any authenticated role**
 */
export const getFeatures = (
    userId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<GetFeatures200>(
      {url: `/api/${userId}/features`, method: 'GET', signal
    },
      options);
    }




export const getGetFeaturesQueryKey = (userId: string,) => {
    return [
    `/api/${userId}/features`
    ] as const;
    }


export const getGetFeaturesQueryOptions = <TData = Awaited<ReturnType<typeof getFeatures>>, TError = ErrorType<unknown>>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatures>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeaturesQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeatures>>> = ({ signal }) => getFeatures(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeatures>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFeaturesQueryResult = NonNullable<Awaited<ReturnType<typeof getFeatures>>>
export type GetFeaturesQueryError = ErrorType<unknown>


export function useGetFeatures<TData = Awaited<ReturnType<typeof getFeatures>>, TError = ErrorType<unknown>>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatures>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeatures>>,
          TError,
          Awaited<ReturnType<typeof getFeatures>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeatures<TData = Awaited<ReturnType<typeof getFeatures>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatures>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeatures>>,
          TError,
          Awaited<ReturnType<typeof getFeatures>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeatures<TData = Awaited<ReturnType<typeof getFeatures>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatures>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetFeatures<TData = Awaited<ReturnType<typeof getFeatures>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatures>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFeaturesQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Authorities: **Any authenticated role**
 */
export const getFeatureByName = (
    userId: string,
    featureName: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<boolean>(
      {url: `/api/${userId}/features/${featureName}`, method: 'GET', signal
    },
      options);
    }




export const getGetFeatureByNameQueryKey = (userId: string,
    featureName: string,) => {
    return [
    `/api/${userId}/features/${featureName}`
    ] as const;
    }


export const getGetFeatureByNameQueryOptions = <TData = Awaited<ReturnType<typeof getFeatureByName>>, TError = ErrorType<unknown>>(userId: string,
    featureName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatureByName>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeatureByNameQueryKey(userId,featureName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeatureByName>>> = ({ signal }) => getFeatureByName(userId,featureName, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(userId && featureName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeatureByName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFeatureByNameQueryResult = NonNullable<Awaited<ReturnType<typeof getFeatureByName>>>
export type GetFeatureByNameQueryError = ErrorType<unknown>


export function useGetFeatureByName<TData = Awaited<ReturnType<typeof getFeatureByName>>, TError = ErrorType<unknown>>(
 userId: string,
    featureName: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatureByName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeatureByName>>,
          TError,
          Awaited<ReturnType<typeof getFeatureByName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeatureByName<TData = Awaited<ReturnType<typeof getFeatureByName>>, TError = ErrorType<unknown>>(
 userId: string,
    featureName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatureByName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeatureByName>>,
          TError,
          Awaited<ReturnType<typeof getFeatureByName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeatureByName<TData = Awaited<ReturnType<typeof getFeatureByName>>, TError = ErrorType<unknown>>(
 userId: string,
    featureName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatureByName>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetFeatureByName<TData = Awaited<ReturnType<typeof getFeatureByName>>, TError = ErrorType<unknown>>(
 userId: string,
    featureName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatureByName>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFeatureByNameQueryOptions(userId,featureName,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






